<template>
  <div class="px-3 py-1">

    <BModal id="photoModal" ref="photoModalEl" centered hideFooter lazy size="md">
          <b-img rounded :src="photo" style="max-width: 100%; max-height: 100%;"/>
    </BModal>

    <b-row class="mt-1">
          <b-img
            v-if="photo != null"
            rounded
            :src="photo"
            style="height: 300px;width: 250px;"
            @click="show"
          />
    </b-row>

    <b-row class="mt-1">
      <b-form-file
          accept=".jpg, .png, .gif, .jpeg"
          :hidden="true"
          ref="fileEl"
          plain
          @input="inputPhoto"
        />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          class="mb-75 mr-75"
          @click="upload"
        >
          {{ $t('Upload')}}
        </b-button>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          size="sm"
          class="mb-75 mr-75"
          @click="reset"
        >
          {{ $t('Reset')}}

        </b-button>
    </b-row>
  </div>



</template>

<script>


import { 
  BButton, 
  BCardText, 
  BFormFile, 
  BImg, 
  BLink, 
  BMedia, 
  BMediaAside, 
  BMediaBody,
  BModal,
  BRow
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { computed } from '@vue/composition-api'

export default {
  name: 'Photo',
  components: {
    BRow,
    BFormFile,
    BMedia,
    BMediaBody,
    BMediaAside,
    BLink,
    BImg,
    BButton,
    BCardText,
    BModal
  },
  directives: {
    Ripple,
  },
  emit:['input'],
  props:{
    value:{
      required:true
    }
  },
  setup(props, {root, emit},) {

    const photo = computed({
      get(){
        return props.value
      },
      set(value){
        emit('input', value)
      }
    })

    const inputPhoto = (input) => {
      if(input instanceof File){
        let reader = new FileReader()
        reader.addEventListener('load', () => photo.value = reader.result, false)
        reader.readAsDataURL(input)
      }
    }

    const upload = function(){
      this.$refs.fileEl.$el.click()
    }

    const reset = function(){
      this.$refs.fileEl.reset()
      photo.value = null
    }

    const show = function(){

      this.$refs.photoModalEl.show()
    }


    return {
      inputPhoto,
      upload,
      photo,
      reset,
      show
    }

  }
}
</script>

<style>


</style>
